module.exports = __webpack_public_path__ + "static/queen-393a4277a476889a9febf54de184bc7c.png";